import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoKaj: CultureInfo = {
  name: 'kaj',
  displayName: 'Kaje',
  iso3LanguageCode: 'kaj',
  iso2LanguageCode: 'kaj',
  ietfLanguageTag: 'kaj',
  parent: null
};
